"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheControlInterceptor = void 0;
const constants_1 = require("../../../http-client/constants");
class CacheControlInterceptor {
    runWhen(config) {
        var _a;
        return ((_a = config === null || config === void 0 ? void 0 : config.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== 'get';
    }
    onRequest(config) {
        const headers = config.headers;
        if (!headers[constants_1.CACHE_CONTROL_HEADER_NAME]) {
            headers[constants_1.CACHE_CONTROL_HEADER_NAME] = constants_1.CACHE_CONTROL_VALUE;
        }
        if (!headers.Pragma) {
            headers.Pragma = constants_1.CACHE_CONTROL_VALUE;
        }
        if (!headers.Expires) {
            headers.Expires = 0;
        }
        return config;
    }
}
exports.CacheControlInterceptor = CacheControlInterceptor;
